'use client';
import { Provider } from 'react-redux';
import { store } from './store';
import {BackgroundImageProvider} from "@/shared/BackgroundImageComponent/BackgroundImageProvider";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {FC, ReactNode} from "react";

interface ProvidersProps {
  children: React.ReactNode;
}

const RecaptchaProvider: FC<{children: ReactNode}> = ({ children }) => {
  if (process.env.NEXT_PUBLIC_IS_LOCAL === 'true')
    return <>{ children }</>
  return <GoogleReCaptchaProvider
    reCaptchaKey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY || ''}
    scriptProps={{
      appendTo: 'head',
    }}
  >
    { children }
  </GoogleReCaptchaProvider>
}

export function Providers({ children }: ProvidersProps) {
  return <Provider store={store}>
    <RecaptchaProvider>
      <BackgroundImageProvider>
        {children}
      </BackgroundImageProvider>
    </RecaptchaProvider>
  </Provider>;
}
